
export const TODO_TYPES = ["Write EMail", "Answer EMail", "Call", "other"]
export const TODO_STATUS = {
    Open: "Open",
    InProgress: "In Progress",
    Done: "Done"
};

const READ_KEY = 'is_read';
const DELETED_KEY = 'is_deleted';
const FOLDER_KEY = 'folder';

export const EDITABLE_KEYS = new Set([READ_KEY, DELETED_KEY, FOLDER_KEY]);

export const NOTIFICATION_TIMEOUT = 3000;
export const MAX_NOTIFICATIONS = 5

export const LOCALE = 'de-DE'

export const EventScheduleStatus = {
    NO_SCHEDULE: 'no_schedule',
    CALCULATING: 'calculating',
    READY: 'ready',
    OUTDATED: 'outdated',
};